(() => {
  function initialize() {
    document.querySelectorAll('[data-hg-badge-picker]').forEach(root => {
      if (root.dataset.enhanced) return;
      const data = document.querySelector('[data-hg-badge-strings]');
      if (!data) return;
      const t = JSON.parse(data.textContent);
      const requestedVariant = new URLSearchParams(window.location.search).get('variant');
      const currentVariant = document.querySelector('#variant-id')?.value;
      let hasChosen = Boolean(requestedVariant && requestedVariant === currentVariant);
      const original = root.querySelector('.option-values');
      const labels = [...original.querySelectorAll('.option-swatch')];
      const classify = title => {
        const n = title.toLowerCase();
        if (n.includes('stainless')) return {group:'steel',key:n.includes('powder')?'yes_powder':'no_powder'};
        if (n.includes('full color') || n.includes('full-colour')) return {group:'color',key:'full_color'};
        for (const [word,key] of [['brushed silver','silver'],['brushed gold','gold'],['wood grain','wood'],['black on red','black_red'],['charcoal on white','charcoal_white'],['charcoal on black','charcoal_black'],['brushed copper','copper']]) {
          if (n.includes(word)) return {group:'engraved',key};
        }
        return null;
      };
      const mapped = labels.map(label => ({label,...classify(label.dataset.value)}));
      if (mapped.some(x => !x.group)) return;
      root.dataset.enhanced = 'true';
      original.removeAttribute('role');
      original.removeAttribute('aria-label');
      original.classList.add('hg-badge-options');
      const groups = ['steel','engraved','color'];
      const order = ['no_powder','yes_powder','silver','gold','wood','black_red','charcoal_white','charcoal_black','copper','full_color'];
      const details = [];
      groups.forEach(group => {
        const choices = mapped.filter(x => x.group === group).sort((a,b) => order.indexOf(a.key)-order.indexOf(b.key));
        if (!choices.length) return;
        const panel = document.createElement('details');
        panel.className = 'hg-badge-family';panel.dataset.family = group;
        const summary = document.createElement('summary');
        const title = document.createElement('strong');title.textContent = t[group];
        const status = document.createElement('span');status.className = 'hg-badge-family__status';
        summary.append(title,status);panel.append(summary);
        const body = document.createElement('div');body.className = 'hg-badge-family__body';
        const help = document.createElement('p');help.textContent = t[group+'_help'];body.append(help);
        const options = document.createElement('div');options.className = 'hg-badge-family__choices';options.setAttribute('role','radiogroup');options.setAttribute('aria-label',group === 'steel'?t.powder_question:t[group]);
        if (group === 'steel') {const q=document.createElement('p');q.className='hg-badge-question';q.textContent=t.powder_question;body.append(q);}
        choices.forEach(({label,key}) => {
          label.querySelector('.option-swatch__label').textContent = t[key];
          const optionIndex = Number(root.dataset.optionIndex || 0);
          const variant = window.__product?.variants.find(v => v['option' + (optionIndex + 1)] === label.dataset.value && v.featured_image);
          if (variant) {
            const thumbnail = document.createElement('img');
            const source = new URL(variant.featured_image.src,window.location.origin);
            source.searchParams.set('width','160');
            thumbnail.src = source.href;
            thumbnail.alt = '';
            thumbnail.width = 56;
            thumbnail.height = 44;
            thumbnail.loading = 'lazy';
            thumbnail.className = 'hg-badge-thumbnail';
            thumbnail.addEventListener('error',()=>thumbnail.remove(),{once:true});
            label.prepend(thumbnail);
          }
          label.dataset.finish = key;
          const input=label.querySelector('input');input.setAttribute('aria-label',t[key]);
          options.append(label);
        });
        body.append(options);panel.append(body);original.append(panel);details.push({panel,status,choices});
        summary.addEventListener('click', event => {
          if (panel.open) return;
          event.preventDefault();
          hasChosen = true;
          details.forEach(x => x.panel.open = x.panel === panel);
          const selected = choices.find(x => x.label.querySelector('input').checked);
          const next = selected || choices.find(x => !x.label.querySelector('input').disabled);
          next?.label.click();
          sync();
        });
      });
      function sync() {
        details.forEach(({panel,status,choices}) => {
          const selected = hasChosen && choices.find(x=>x.label.querySelector('input').checked);
          panel.classList.toggle('is-selected-family',Boolean(selected));
          status.textContent = selected ? `${t.selected}: ${t[selected.key]}` : (choices.length === 1 ? t.one_finish : t.finish_count.replace('{count}',choices.length));
        });
      }
      root.addEventListener('click',event=>{const label=event.target.closest('.option-swatch');if(!label)return;hasChosen=true;details.forEach(x=>x.panel.open=x.choices.some(c=>c.label===label));sync();});
      root.addEventListener('change',sync);
      details.forEach(({panel,choices})=>panel.open=hasChosen && choices.some(x=>x.label.querySelector('input').checked));
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initialize); else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
